import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

export const TwinkleIcon = ({
  width = 14,
  height = 14,
  fill = '#991b1b'
}: SVGComponentProps) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#a)">
        <path
          d="M7.566 1.021a.583.583 0 0 0-1.132 0l-.759 3.037c-.158.632-.21.815-.302.957a1.2 1.2 0 0 1-.354.354c-.14.09-.324.144-.957.302l-3.037.76a.583.583 0 0 0 0 1.13l3.037.76c.633.158.816.211.957.302s.263.212.354.354.144.325.302.957l.76 3.037a.583.583 0 0 0 1.131 0l.76-3.037c.157-.632.21-.815.301-.957s.212-.263.354-.354.325-.144.957-.302l3.037-.76a.583.583 0 0 0 0-1.13l-3.037-.76c-.632-.158-.815-.21-.957-.302a1.2 1.2 0 0 1-.354-.354c-.09-.142-.144-.325-.302-.957z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill={'#fff'} d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
